<template>
    <div class="table-responsive table-container">
        <h3 style="margin-bottom: 10px">รายการจองผลิตภัณฑ์</h3>
        <div v-if="loading" style="margin-top: 10px">กำลังโหลดข้อมูล...</div>
        <div v-else>
            <div v-if="error" style="margin-top: 10px; color: red">
                {{ error }}
                <button
                    class="btn btn-sm btn-primary"
                    style="margin-left: 10px"
                    @click="fetchPreorders"
                >
                    ลองใหม่
                </button>
            </div>
            <div v-else>
                <div v-if="tableData.length === 0" style="margin-top: 10px">
                    ไม่พบข้อมูลรายการจอง
                </div>
                <table
                    v-else
                    class="table table-striped"
                    style="width: 100%; font-size: 14px"
                >
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 5%">ลำดับ</th>
                            <th style="width: 10%">วันที่ซื้อ</th>
                            <th style="width: 10%">รายการสินค้า</th>
                            <th style="width: 5%">ราคา</th>
                            <th style="width: 6%">จํานวน</th>
                            <th style="width: 8%">รวมทั้งสิ้น</th>
                            <th style="width: 15%">ข้อมูลลูกค้า</th>
                            <th style="width: 15%">ข้อมูลการจัดส่ง</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in tableData" :key="index">
                            <td class="text-center">
                                {{ index + 1 }}
                                <button
                                    style="margin-top: 10px"
                                    class="btn btn-primary"
                                    @click="openModalWithData(item)"
                                >
                                    รายละเอียด
                                </button>
                            </td>
                            <td>
                                <span
                                    v-html="
                                        formatThaiDateTime(
                                            item.order_date,
                                        ).replace('\n', '<br>')
                                    "
                                ></span>
                            </td>
                            <td>{{ item.product_name }}</td>
                            <td>{{ formatNumber(item.unit_price) }}</td>
                            <td>{{ item.quantity }}</td>
                            <td>{{ formatNumber(item.total_price) }}</td>
                            <!-- Customer Detail -->
                            <td>
                                <ul style="font-size: 14px !important">
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >ชื่อลูกค้า :
                                        </strong>
                                        {{ item.customer_name }}
                                    </li>
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >เบอร์โทร :
                                        </strong>
                                        {{ item.customer_phone }}
                                    </li>
                                    <li
                                        style="font-size: 14px !important"
                                        v-if="item.customer_email"
                                    >
                                        <strong style="font-weight: 500"
                                            >อีเมล :
                                        </strong>
                                        {{ item.customer_email }}
                                    </li>
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >ชำระผ่าน :
                                        </strong>
                                        {{ item.payment_method }}
                                    </li>
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >สถานะ :
                                        </strong>
                                        {{
                                            mapPaymentStatus(
                                                item.payment_status,
                                            )
                                        }}
                                    </li>
                                </ul>
                            </td>
                            <!-- Delivery Detail -->
                            <td>
                                <ul style="font-size: 14px !important">
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >ที่อยู่ :
                                        </strong>
                                        {{ item.delivery_address }}
                                    </li>
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >วันนัดส่ง :
                                        </strong>
                                        {{ formatDate(item.delivery_date) }}
                                    </li>
                                    <li
                                        style="font-size: 14px !important"
                                        v-if="item.invoice_number"
                                    >
                                        <strong style="font-weight: 500"
                                            >ใบแจ้งหนี้ :
                                        </strong>
                                        {{ item.invoice_number }}
                                    </li>
                                    <li style="font-size: 14px !important">
                                        <strong style="font-weight: 500"
                                            >เลขคำสั่งซื้อ :
                                        </strong>
                                        {{ item.order_number }}
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- Modal for preorder details -->
        <div v-if="showModal" class="modal-overlay">
            <div class="modal-content">
                <button class="close-button" @click="closeModal">×</button>
                <h3>รายละเอียดคำสั่งจอง</h3>
                <hr />
                <div v-if="selectedOrder" class="row">
                    <div class="col-md-6 col-sm-12">
                        <strong>ข้อมูลลูกค้า</strong>
                        <ul style="font-size: 14px !important">
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >ชื่อลูกค้า :
                                </strong>
                                {{ selectedOrder.customer_name }}
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >เบอร์โทร :
                                </strong>
                                {{ selectedOrder.customer_phone }}
                            </li>
                            <li
                                style="font-size: 14px !important"
                                v-if="selectedOrder.customer_email"
                            >
                                <strong style="font-weight: 500"
                                    >อีเมล :
                                </strong>
                                {{ selectedOrder.customer_email }}
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >ชำระผ่าน :
                                </strong>
                                {{ selectedOrder.payment_method }}
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >สถานะการชำระ :
                                </strong>
                                {{
                                    mapPaymentStatus(
                                        selectedOrder.payment_status,
                                    )
                                }}
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <strong>ข้อมูลการจัดส่ง</strong>
                        <ul style="font-size: 14px !important">
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >ที่อยู่ :
                                </strong>
                                {{ selectedOrder.delivery_address }}
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >วันนัดส่ง :
                                </strong>
                                {{ formatDate(selectedOrder.delivery_date) }}
                            </li>
                            <li
                                style="font-size: 14px !important"
                                v-if="selectedOrder.invoice_number"
                            >
                                <strong style="font-weight: 500"
                                    >ใบแจ้งหนี้ :
                                </strong>
                                {{ selectedOrder.invoice_number }}
                            </li>
                        </ul>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="mt-3 col-md-12 col-sm-12">
                        <strong>ข้อมูลการจอง</strong>
                        <ul style="font-size: 14px !important">
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >เลขคำสั่งจอง :
                                </strong>
                                {{ selectedOrder.order_number }}
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >ผลิตภัณฑ์ :
                                </strong>
                                {{ selectedOrder.product_name }}
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >ราคา :
                                </strong>
                                {{ formatNumber(selectedOrder.unit_price) }} บาท
                                <strong style="font-weight: 500">
                                    จำนวน :
                                </strong>
                                {{ selectedOrder.quantity }} ชิ้น
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >ราคารวมทั้งสิ้น :
                                </strong>
                                {{
                                    formatNumber(selectedOrder.total_price)
                                }}
                                บาท
                            </li>
                            <li style="font-size: 14px !important">
                                <strong style="font-weight: 500"
                                    >วันที่จอง :
                                </strong>
                                <span
                                    v-html="
                                        formatThaiDateTime(
                                            selectedOrder.order_date,
                                        )
                                    "
                                ></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "PreordersTable",
    data() {
        return {
            tableData: [],
            loading: false,
            error: null,
            showModal: false,
            selectedOrder: null,
        };
    },
    async mounted() {
        await this.fetchPreorders();
    },
    methods: {
        async fetchPreorders() {
            this.loading = true;
            this.error = null;
            try {
                const res = await axios.get(
                    // "https://center-data.rcbt-sip.com/api/preorders",
                    "https://api.xn--42cf1c1az5dtau6v.com/api/preorders",
                );
                console.log("Preorders API raw response:", res.data);
                // Support both plain array responses and { data: [...] }
                let raw = Array.isArray(res?.data)
                    ? res.data
                    : res?.data?.data || [];
                console.log("Preorders array length:", raw.length);
                const community_id = localStorage.getItem("community_id");
                const role_id = localStorage.getItem("role_id");
                console.log(
                    "User role_id:",
                    role_id,
                    "community_id:",
                    community_id,
                );
                // Filter by community_id if not admin AND has valid community_id
                if (
                    role_id != 1 &&
                    community_id &&
                    community_id !== "null" &&
                    community_id !== "undefined"
                ) {
                    const commId = parseInt(community_id);
                    raw = raw.filter((item) => {
                        const topLevelComm = parseInt(item?.community_id);
                        if (!isNaN(topLevelComm))
                            return topLevelComm === commId;
                        const productComm = parseInt(
                            item?.product_community?.community_id,
                        );
                        if (!isNaN(productComm)) return productComm === commId;
                        try {
                            const epd = item?.external_product_data
                                ? JSON.parse(item.external_product_data)
                                : null;
                            const extComm = parseInt(
                                epd?.external_data?.community_id ||
                                    epd?.community_id,
                            );
                            if (!isNaN(extComm)) return extComm === commId;
                        } catch (_) {
                            return false; // invalid JSON; exclude item
                        }
                        return false;
                    });
                    console.log("Filtered preorders length:", raw.length);
                }
                raw = raw.filter((item) => item?.order_type === "preorder");
                console.log("Filtered by order_type=preorder length:", raw.length);
                
                console.log("Final raw data to map:", raw);
                this.tableData = raw.map((item) => {
                    // Parse product from external_product_data if present
                    let product_name = "ไม่ระบุ";
                    let unit_price = parseFloat(item?.unit_price);
                    let total_price = parseFloat(item?.total_price);
                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            product_name =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                product_name;
                            if (isNaN(unit_price))
                                unit_price = parseFloat(epd?.price);
                        }
                    } catch (_) {
                        // noop: ignore JSON parse errors
                        void 0;
                    }
                    const quantity = parseInt(item?.quantity);
                    const qtySafe = isNaN(quantity) ? 0 : quantity;
                    const priceSafe = isNaN(unit_price) ? 0 : unit_price;
                    const totalSafe = !isNaN(total_price)
                        ? total_price
                        : priceSafe * qtySafe;

                    return {
                        order_number: item?.order_number || "-",
                        product_name,
                        quantity: qtySafe,
                        unit_price: priceSafe,
                        total_price: totalSafe,
                        order_date:
                            item?.order_date ||
                            item?.payment_date ||
                            item?.created_at ||
                            "",
                        customer_name: item?.customer_name || "-",
                        customer_phone: item?.customer_phone || "-",
                        customer_email: item?.customer_email || "",
                        payment_method: item?.payment_method || "-",
                        payment_status: item?.payment_status || "-",
                        delivery_address: item?.delivery_address || "-",
                        delivery_date: item?.delivery_date || "",
                        invoice_number:
                            Array.isArray(item?.invoices) &&
                            item.invoices[0]?.invoice_number
                                ? item.invoices[0].invoice_number
                                : null,
                    };
                });
                console.log("Final tableData length:", this.tableData.length);
                console.log("Sample tableData:", this.tableData.slice(0, 2));
            } catch (e) {
                console.error("Error fetching preorders:", e);
                const status = e?.response?.status;
                this.error = status
                    ? `ไม่สามารถโหลดข้อมูลรายการจองได้ (รหัส ${status})`
                    : "ไม่สามารถโหลดข้อมูลรายการจองได้";
            } finally {
                this.loading = false;
            }
        },
        formatNumber(value) {
            const num = parseFloat(value);
            return isNaN(num) ? "0" : new Intl.NumberFormat().format(num);
        },
        formatDate(value) {
            if (!value) return "-";
            const d = new Date(value);
            if (isNaN(d.getTime())) return "-";
            const options = { year: "numeric", month: "short", day: "numeric" };
            return d.toLocaleDateString("th-TH", options);
        },
        mapPaymentStatus(status) {
            if (!status) return "-";
            const map = {
                paid: "ชำระแล้ว",
                unpaid: "ยังไม่ชำระ",
                pending: "รอตรวจสอบ",
            };
            return map[status] || status;
        },
        formatThaiDateTime(datetime) {
            if (!datetime) return "-";
            const date = new Date(datetime);
            if (isNaN(date.getTime())) return "-";
            const utc = date.getTime() + date.getTimezoneOffset() * 60000;
            const thTime = new Date(utc + 7 * 60 * 60 * 1000);
            const options = { year: "numeric", month: "short", day: "numeric" };
            const timeOptions = {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            };
            const dateStr = thTime.toLocaleDateString("th-TH", options);
            const timeStr = thTime.toLocaleTimeString("th-TH", timeOptions);
            return `${dateStr}<br>เวลา ${timeStr} น.`;
        },
        openModalWithData(item) {
            this.selectedOrder = item;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedOrder = null;
        },
    },
};
</script>

<style scoped>
.table-container {
    max-height: 600px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.table {
    margin: 0;
    width: 100%;
}
.table th {
    white-space: nowrap;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background: white;
    width: 1200px;
    max-width: 90%;
    height: auto;
    max-height: 90vh;
    padding: 2rem;
    position: relative;
    overflow-y: auto;
    border-radius: 10px;
}

.close-button {
    position: absolute;
    top: 1rem;
    right: 2rem;
    background: red;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    padding: 0px;
    width: 50px;
    font-size: 2rem;
}
</style>
